(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["image-banner"] && !window.DesignMode) return;
  try {
    
    const prices = document.getElementsByClassName('data-price');

    let lowestPrice = 9999;
    let lowestPriceIndex;

    for(i = 0; i < prices.length; i++){
      const price = Number(prices[i].innerText.substring(1));
      if(price < lowestPrice){
        lowestPrice = price;
        lowestPriceIndex = i;
      }
    }
    
    lowestBundlePrice = prices[lowestPriceIndex].innerText;

    const lowestVariantBlocks = document.getElementsByClassName('lowest-bundle-text');

    for(i = 0; i < lowestVariantBlocks.length; i++){
      lowestVariantBlocks[i].innerText = lowestBundlePrice;
    }

  } catch(e) { console.error(e); }
})();
      })();
